<template lang="pug">
.section-body
  //- .section-title.m-0
  //-   h5 {{ $t("ui.todays_highlights") }}
  h4.d-flex
    //- | {{ todayDate }}
    div(style="width:265px !important;")
      DateRangePicker(:value="dateRange" @update="getData")
    span.badge.badge-primary(@click="getData()")
      i.fas.fa-sync-alt
  .row
    .col-12
      .card.mb-0
        .card-body.dashboardadmin           
          .row
            //- .col-12.col-md-6.col-lg-4
            //-   .card.card-primary
            //-     .card-header
            //-       h4
            //-         i.fas.fa-shopping-cart.mr-1
            //-         span.text-uppercase.font-weight-bold.title(:title="$t('ui.cart_verified_signup')") {{ $t("ui.cart_verified_signup") }}
            //-         span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tCartVerified,yCartVerified)") {{ showPercentage(tCartVerified,yCartVerified) }}
            //-       .card-header-action
            //-         i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.cart_verified_signup')")
            //-     .card-body
            //-       .text-value.row.col-sm-12
            //-         h3(:class="$helpers.fontClassName(tCartVerified)" :title="$n(tCartVerified, 'integer')") {{ $n(tCartVerified, 'integer') }}
            //-         h3 &nbsp;/&nbsp;
            //-         h3(:class="$helpers.fontClassName(tCartSignup)" :title="$n(tCartSignup, 'integer')") {{ $n(tCartSignup, 'integer') }}
            //-       .text-uppercase.text-muted(:title="totalCartUser") {{ $t("ui.total_cart") }} : 
            //-         span.font-weight-bold {{ totalCartUser }}
            //-       .text-uppercase &nbsp;
            .col-12.col-md-6.col-lg-4
              .card.card-secondary
                .card-header
                  h4
                    i.fas.fa-globe.mr-1
                    span.text-uppercase.font-weight-bold.title(:title="$t('ui.website_launched')") {{ $t("ui.website_launched") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tOperator,yOperator)") {{ showPercentage(tOperator,yOperator) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.website_launched')")
                .card-body
                  .text-value.row.col-sm-12
                    h3(:class="$helpers.fontClassName(tOperator)" :title="$n(tOperator, 'integer')") {{ $n(tOperator, 'integer') }}  
                  .text-uppercase.text-muted(:title="totalOperator") {{ $t("ui.total_operators") }} : 
                    span.font-weight-bold {{ totalOperator }}
                  .text-uppercase.text-muted(:title="activeSite") {{ $t("ui.today_active") }} : 
                    span.font-weight-bold {{ activeSite }}
            .col-12.col-md-6.col-lg-4
              .card.card-info
                .card-header
                  h4
                    i.fas.fa-user-plus.mr-1
                    span.text-uppercase.font-weight-bold.title(:title="$t('ui.new_player_verified_signup')") {{ $t("ui.new_player_verified_signup") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tPlayerVerified,yPlayerVerified)") {{ showPercentage(tPlayerVerified,yPlayerVerified) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.new_player_verified_signup')")
                .card-body
                  .text-value.row.col-sm-12
                    h3(:class="$helpers.fontClassName(tPlayerVerified)" :title="$n(tPlayerVerified, 'integer')") {{ $n(tPlayerVerified, 'integer') }}
                    h3 &nbsp;/&nbsp;
                    h3(:class="$helpers.fontClassName(tPlayerSignup)" :title="$n(tPlayerSignup, 'integer')") {{ $n(tPlayerSignup, 'integer') }}
                  .text-uppercase.text-muted(:title="totalPlayer") {{ $t("ui.total_players") }} : 
                    span.font-weight-bold {{ totalPlayer }}
                  .text-uppercase &nbsp;
            .col-12.col-md-6.col-lg-4
              .card.card-warning
                .card-header
                  h4
                    i.fas.fa-money-bill.mr-1
                    span.text-uppercase.font-weight-bold.title(:title="$t('ui.depo_withdrawal_diff')") {{ $t("ui.depo_withdrawal_diff") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tDepoWithDiff,yDepoWithDiff)") {{ showPercentage(tDepoWithDiff,yDepoWithDiff) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.depo_withdrawal_diff')")
                .card-body
                  .text-value.row.col-sm-12
                    h3(:class="$helpers.fontClassName(tDepoWithDiff)" :title="$n(tDepoWithDiff, 'integer')") {{ $n(tDepoWithDiff, 'integer') }}
                  .text-uppercase.text-muted(:title="tDeposit") {{ $t("ui.deposit") }} : 
                    span.font-weight-bold.text-info {{ $n(tDeposit, 'currency') }}
                    template(v-if="uniqueMemberDeposit > 0")
                      span.font-weight-bold.ml-1 | {{ uniqueMemberDeposit }}
                      span.ml-1 {{ $t("ui.players") }}
                  .text-uppercase.text-muted(:title="tWithdrawal") {{ $t("ui.withdrawal") }} : 
                    span.font-weight-bold.text-danger {{ $n(tWithdrawal, 'currency') }}
                    template(v-if="uniqueMemberWithdrawal > 0")
                      span.font-weight-bold.ml-1 | {{ uniqueMemberWithdrawal }}
                      span.ml-1 {{ $t("ui.players") }}
            .col-12.col-md-6.col-lg-4
              .card.card-danger
                .card-header
                  h4
                    i.fas.fa-money-bill.mr-1
                    span.text-uppercase.font-weight-bold.title(:title="$t('ui.bonus')") {{ $t("ui.bonus") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tBonus,yBonus)") {{ showPercentage(tBonus,yBonus) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.bonus')")
                .card-body
                  .text-value.row.col-sm-12
                    h3(:class="$helpers.fontClassName(tBonus)" :title="$n(tBonus, 'integer')") {{ $n(tBonus, 'integer') }}
                  .text-uppercase.text-muted(:title="promoClaim") {{ $t("ui.claim_count") }} : 
                    span.font-weight-bold {{ promoClaim }}
                  .text-uppercase &nbsp;
            .col-12.col-md-6.col-lg-4
              .card.card-primary
                .card-header
                  h4
                    i.fas.fa-money-bill.mr-1
                    span.text-uppercase.font-weight-bold.title(:title="$t('ui.ggr')") {{ $t("ui.ggr") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tGGR,yGGR)") {{ showPercentage(tGGR,yGGR) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.ggr')")
                .card-body
                  .text-value.row.col-sm-12
                    h3(:class="$helpers.fontClassName(tGGR)" :title="$n(tGGR, 'integer')") {{ $n(tGGR, 'integer') }}
                  .text-uppercase.text-muted(:title="systemBalance") {{ $t("ui.member_balance") }} : 
                    span.font-weight-bold(:class="$helpers.fontClassName(systemBalance)") {{ $n(systemBalance, 'currency') }}
                  .text-uppercase &nbsp;
            .col-12.col-md-6.col-lg-4
              .card.card-secondary
                .card-header
                  h4
                    i.fas.fa-money-bill.mr-1
                    span.text-uppercase.font-weight-bold.title(:title="$t('ui.turnover')") {{ $t("ui.turnover") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tTurnover,yTurnover)") {{ showPercentage(tTurnover,yTurnover) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.turnover')")
                .card-body
                  .text-value.row.col-sm-12
                    h3(:class="$helpers.fontClassName(tTurnover)" :title="$n(tTurnover, 'integer')") {{ $n(tTurnover, 'integer') }}
                  .text-uppercase.text-muted(:title="rtp") {{ $t("ui.rtp") }} : 
                    span.font-weight-bold(:class="$helpers.fontClassName(rtp)") {{ rtp }}
                  .text-uppercase &nbsp;
            .col-12.col-md-6.col-lg-4
              .card.card-info
                .card-header
                  h4
                    i.fas.fa-money-bill.mr-1
                    span.text-uppercase.font-weight-bold.title(:title="$t('ui.free_credit_withdrawal_amount')") {{ $t("ui.fc_withdrawal_amount") }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.free_credit_withdrawal_amount')")
                .card-body
                  .text-value.row.col-sm-12
                    h3(:class="$helpers.fontClassName(tWithdrawalFree)" :title="$n(tWithdrawalFree, 'currency')") {{ $n(tWithdrawalFree, 'currency') }}

          //- .row
          //-   .col-sm-12.col-md-6.col-lg-6
          //-     .card
          //-       .card-header
          //-         h4
          //-           i.fas.fa-list-ol.mr-2
          //-           span.text-uppercase.font-weight-bold(:title="$t('ui.top_purchase')") {{ $t("ui.top_purchase") }}
          //-       .card-body
          //-         table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle(width="100%")
          //-           thead.thead-light
          //-             tr
          //-               th.text-center(width="15%")
          //-                 span #
          //-               th(width="45%")
          //-                 span(:title="$t('ui.cart_user_id')") {{ $t("ui.cart_user_id") }}
          //-               th.text-right(width="40%")
          //-                 span(:title="$t('ui.amount')") {{ $t("ui.amount") }}
          //-           tbody
          //-             tr(v-if="top10purchase.length <= 0")
          //-               td.text-center(colspan="3").text-center
          //-                 span {{ $t('message.no_data_available') }}
          //-             tr(v-for="(item, index) in top10purchase")
          //-               td.text-center
          //-                 span {{ index + 1 }}
          //-               td
          //-                 span(:title="item.user_id") {{ item.user_id }}
          //-               td.text-right
          //-                 span(:title="$n(item.package_price, 'currency')") {{ $n(item.package_price, 'currency') }}
          //-   .col-sm-12.col-md-6.col-lg-6
          //-     .card
          //-       .card-header
          //-         h4
          //-           i.fas.fa-list-ol.mr-2
          //-           span.text-uppercase.font-weight-bold(:title="$t('ui.top_theme')") {{ $t("ui.top_theme") }}
          //-       .card-body
          //-         table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle(width="100%")
          //-           thead.thead-light
          //-             tr
          //-               th.text-center(width="15%")
          //-                 span #
          //-               th(width="45%")
          //-                 span(:title="$t('ui.theme_code')") {{ $t("ui.theme_code") }}
          //-               th(width="40%")
          //-                 span(:title="$t('ui.total_site')") {{ $t("ui.total_site") }}
          //-           tbody
          //-             tr.text-center(v-if="top10theme <= 0")
          //-               td(colspan="3").text-center
          //-                 span {{ $t('message.no_data_available') }}
          //-             tr(v-for="(item, index) in top10theme")
          //-               td.text-center
          //-                 span {{ index + 1 }}
          //-               td
          //-                 span(:title="item.theme_code") {{ item.theme_code }}
          //-               td
          //-                 span(:title="item.theme_count") {{ item.theme_count }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    DateRangePicker
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    working_date: null,
    dateRange: {
      startDate: null,
      endDate: null,
    },
    systemBalance: 0,
    totalCartUser: 0,
    tCartSignup: 0,
    yCartSignup: 0,
    tCartVerified: 0,
    yCartVerified: 0,
    totalOperator: 0,
    tOperator: 0,
    yOperator: 0,
    activeSite: 0,
    totalPlayer: 0,
    tPlayerSignup: 0,
    tPlayerVerified: 0,
    yPlayerSignup: 0,
    yPlayerVerified: 0,
    tDeposit: 0,
    tWithdrawal: 0,
    tDepoWithDiff: 0,
    yDeposit: 0,
    yWithdrawal: 0,
    yDepoWithDiff: 0,
    uniqueMemberDeposit: 0,
    uniqueMemberWithdrawal: 0,
    tBonus: 0,
    yBonus: 0,
    promoClaim: 0,
    tGGR: 0,
    yGGR: 0,
    tTurnover: 0,
    yTurnover: 0,
    rtp: 0,
    tWithdrawalFree: 0
    // top10purchase: [],
    // top10theme: [],
  }),
  computed: {
    isAdmin() {
      return this.$store.getters.accountType === 5;
    }
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      this.dateRange.startDate = this.$moment(new Date).format("YYYY-MM-DD");
      this.dateRange.endDate = this.$moment(new Date).format("YYYY-MM-DD");

      if (this.isToday()) {
        this.getDashboard();
      } else {
        this.getDashboardRange();
      }
      // if(!this.isOperator && this.showActionButton('systembalance'))
      this.getSystemBalance();
    }
  },
  methods: {
    showBadge(today, yesterday) {
      if (today == null || yesterday == null || today === "" || yesterday === "") {
        return ""; 
      }

      if (yesterday === 0) {
        return "badge-warning"; 
      }

      const percentageIncrease = ((today - yesterday) / Math.abs(yesterday)) * 100;

      if (percentageIncrease > 0) {
        return "badge-success";
      } else if (percentageIncrease < 0) {
        return "badge-danger";
      } else {
        return "badge-info"; 
      }
    },
    showPercentage(today, yesterday) {
      if (today == null || yesterday == null || today === "" || yesterday === "") {
        return ""; 
      }

      if (yesterday === 0) {
        return "N/A";
      }
      const percentageIncrease = ((today - yesterday) / Math.abs(yesterday)) * 100;
      
      const formattedResult = percentageIncrease > 0 
        ? `+${percentageIncrease.toFixed(2)}%`
        : `${percentageIncrease.toFixed(2)}%`;

      return formattedResult;
    },
    isToday() {
      return this.dateRange.startDate === this.dateRange.endDate
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 30)
        return false;
      else
        return true;
    },
    getSystemBalance: function() {
      let url = config.systemBalanceUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: null,
        audit_by: this.$store.getters.loginId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.systemBalance = response.data.dt.length > 0 ? response.data.dt[0].system_balance : 0;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getData(currentValue) {
      if(currentValue) {
        this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      }

      if (this.isToday()) {
        this.getDashboard();
      } else {
        this.getDashboardRange();
      }
    },
    getDashboard: function() {
      // if(!this.isAdmin) return
      let url = config.dashboardUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        working_date: this.dateRange.startDate
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.clearData();
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                // if (response.data.ds.totalcart.length > 0) {
                //   this.totalCartUser = response.data.ds.totalcart[0].user_count
                // }

                // if (response.data.ds.cartverified.length > 0) {
                //   this.tCartVerified = response.data.ds.cartverified[0].verified_count
                // }

                // if (response.data.ds.cartverifiedytd.length > 0) {
                //   this.yCartVerified = response.data.ds.cartverifiedytd[0].verified_count
                // }

                // if (response.data.ds.cartsignup.length > 0) {
                //   this.tCartSignup = response.data.ds.cartsignup[0].signup_count
                // }

                // if (response.data.ds.cartsignupytd.length > 0) {
                //   this.yCartSignup = response.data.ds.cartsignupytd[0].signup_count
                // }

                if (response.data.ds.totaloperator.length > 0) {
                  this.totalOperator = response.data.ds.totaloperator[0].user_count
                }

                if (response.data.ds.operator.length > 0) {
                  this.tOperator = response.data.ds.operator[0].operator_count
                }

                if (response.data.ds.operatorytd.length > 0) {
                  this.yOperator = response.data.ds.operatorytd[0].operator_count
                }

                if (response.data.ds.activesite.length > 0) {
                  this.activeSite = response.data.ds.activesite[0].site_count
                }

                if (response.data.ds.totalplayer.length > 0) {
                  this.totalPlayer = response.data.ds.totalplayer[0].user_count
                }

                if (response.data.ds.player.length > 0) {
                  this.tPlayerSignup = response.data.ds.player[0].signup_count
                  this.tPlayerVerified = response.data.ds.player[0].verified_count
                  this.tDeposit = response.data.ds.player[0].deposit_amount
                  this.tWithdrawal = response.data.ds.player[0].withdrawal_amount
                  this.tDepoWithDiff = this.tDeposit - this.tWithdrawal
                  this.tBonus = response.data.ds.player[0].bonus_amount
                  this.tGGR = response.data.ds.player[0].winlose * -1
                  this.tTurnover = response.data.ds.player[0].valid_turnover
                  this.tWithdrawalFree = response.data.ds.player[0].withdrawal_amount_free

                  if(this.tTurnover != 0) {
                    this.rtp = (((response.data.ds.player[0].valid_turnover + response.data.ds.player[0].winlose) / response.data.ds.player[0].valid_turnover) * 100).toFixed(2) + "%"                    
                  }
                }

                if (response.data.ds.playerytd.length > 0) {
                  this.yPlayerSignup = response.data.ds.playerytd[0].signup_count
                  this.yPlayerVerified = response.data.ds.playerytd[0].verified_count
                  this.yDeposit = response.data.ds.playerytd[0].deposit_amount
                  this.yWithdrawal = response.data.ds.playerytd[0].withdrawal_amount
                  this.yDepoWithDiff = this.yDeposit - this.yWithdrawal
                  this.yBonus = response.data.ds.playerytd[0].bonus_amount
                  this.yGGR = response.data.ds.playerytd[0].winlose * -1
                  this.yTurnover = response.data.ds.playerytd[0].valid_turnover
                }   
                
                if (response.data.ds.uniquemember.length > 0) {
                  this.uniqueMemberDeposit = response.data.ds.uniquemember[0].deposit_player_count
                  this.uniqueMemberWithdrawal = response.data.ds.uniquemember[0].withdrawal_player_count
                }

                if (response.data.ds.promoclaimcount.length > 0) {
                  this.promoClaim = response.data.ds.promoclaimcount[0].claim_count
                }

                // this.top10purchase = response.data.ds.top10purchase
                // this.top10theme = response.data.ds.top10theme

              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getDashboardRange: function() {
      // if(!this.isAdmin) return
      let url = config.dashboardRangeUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.clearData();
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                // if (response.data.ds.totalcart.length > 0) {
                //   this.totalCartUser = response.data.ds.totalcart[0].user_count
                // }

                // if (response.data.ds.cartverified.length > 0) {
                //   this.tCartVerified = response.data.ds.cartverified[0].verified_count
                // }

                // if (response.data.ds.cartsignup.length > 0) {
                //   this.tCartSignup = response.data.ds.cartsignup[0].signup_count
                // }

                if (response.data.ds.totaloperator.length > 0) {
                  this.totalOperator = response.data.ds.totaloperator[0].user_count
                }

                if (response.data.ds.operator.length > 0) {
                  this.tOperator = response.data.ds.operator[0].operator_count
                }

                if (response.data.ds.activesite.length > 0) {
                  this.activeSite = response.data.ds.activesite[0].site_count
                }

                if (response.data.ds.totalplayer.length > 0) {
                  this.totalPlayer = response.data.ds.totalplayer[0].user_count
                }

                if (response.data.ds.player.length > 0) {
                  this.tPlayerSignup = response.data.ds.player[0].signup_count
                  this.tPlayerVerified = response.data.ds.player[0].verified_count
                  this.tDeposit = response.data.ds.player[0].deposit_amount
                  this.tWithdrawal = response.data.ds.player[0].withdrawal_amount
                  this.tDepoWithDiff = this.tDeposit - this.tWithdrawal
                  this.tBonus = response.data.ds.player[0].bonus_amount
                  this.tGGR = response.data.ds.player[0].winlose * -1
                  this.tTurnover = response.data.ds.player[0].valid_turnover
                  this.tWithdrawalFree = response.data.ds.player[0].withdrawal_amount_free

                  if(this.tTurnover != 0) {
                    this.rtp = (((response.data.ds.player[0].valid_turnover + response.data.ds.player[0].winlose) / response.data.ds.player[0].valid_turnover) * 100).toFixed(2) + "%"                    
                  }
                }  
                
                if (response.data.ds.uniquemember.length > 0) {
                  this.uniqueMemberDeposit = response.data.ds.uniquemember[0].deposit_player_count
                  this.uniqueMemberWithdrawal = response.data.ds.uniquemember[0].withdrawal_player_count
                }

                if (response.data.ds.promoclaimcount.length > 0) {
                  this.promoClaim = response.data.ds.promoclaimcount[0].claim_count
                }

                // this.top10purchase = response.data.ds.top10purchase
                // this.top10theme = response.data.ds.top10theme

              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearData: function() {
      this.systemBalance = 0
      this.totalCartUser = 0
      this.tCartSignup = 0
      this.yCartSignup = 0
      this.tCartVerified = 0
      this.yCartVerified = 0
      this.totalOperator = 0
      this.tOperator = 0
      this.yOperator = 0
      this.activeSite = 0
      this.totalPlayer = 0
      this.tPlayerSignup = 0
      this.tPlayerVerified = 0
      this.yPlayerSignup = 0
      this.yPlayerVerified = 0
      this.tDeposit = 0
      this.tWithdrawal = 0
      this.tDepoWithDiff = 0
      this.yDeposit = 0
      this.yWithdrawal = 0
      this.yDepoWithDiff = 0
      this.uniqueMemberDeposit = 0
      this.uniqueMemberWithdrawal = 0
      this.tBonus = 0
      this.yBonus = 0
      this.promoClaim = 0
      this.tGGR = 0
      this.yGGR = 0
      this.tTurnover = 0
      this.yTurnover = 0
      this.rtp = 0
      this.tWithdrawalFree = 0
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>